import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_253: DocMigration = {
  maxSchemaVersion: "0.0.253",
  description: "Migrates conditioned area calculation type to area report settings",
  apply(json: any) {
    if (json.settings) {
      for (const settingId of Object.keys(json.settings)) {
        const planSettings = json.settings[settingId];
        if (planSettings.type !== "PLAN_SETTINGS") {
          continue;
        }

        const conditionedAreaCalculationType = planSettings.conditionedAreaCalculationType;
        if (conditionedAreaCalculationType === undefined) {
          continue;
        }

        let areaReportSettings = planSettings.areaReportSettings;
        if (areaReportSettings === undefined) {
          areaReportSettings = {};
        }
        if (areaReportSettings["CONDITIONED_FLOOR_AREA"] === undefined) {
          areaReportSettings["CONDITIONED_FLOOR_AREA"] = {};
        }

        areaReportSettings["CONDITIONED_FLOOR_AREA"].areaCalculationType = conditionedAreaCalculationType;

        delete planSettings.conditionedAreaCalculationType;

        planSettings.areaReportSettings = areaReportSettings;

        json.settings[settingId] = planSettings;
      }
    }
    return json;
  },
};

export default migration_0_0_253;
